// The AR block (block 0) can have a different number of rows than the others,
// so the row list is rendered for the longest block and trimmed here.
function syncRowOptions() {
  const blockSelect = document.getElementById('block_select');
  const rowSelect = document.getElementById('row_select');
  if (!blockSelect || !rowSelect) return;

  const limit = Number(blockSelect.value === '0' ? rowSelect.dataset.arRows : rowSelect.dataset.rowsPerBlock);
  Array.from(rowSelect.options).forEach(function(option) {
    const outOfRange = option.value !== '' && Number(option.value) > limit;
    option.hidden = outOfRange;
    option.disabled = outOfRange;
    if (outOfRange && option.selected) rowSelect.value = '';
  });
}

function setup() {
  if(document.getElementById('no_place')) {
    document.getElementById('no_place').addEventListener('click', function() {
      document.getElementById('block_select').value = null;
      document.getElementById('row_select').value = null;
      document.getElementById('place').toggleAttribute("hidden");
    })
  }
  if(document.getElementById('block_select')) {
    document.getElementById('block_select').addEventListener('change', syncRowOptions);
    syncRowOptions();
  }
}

document.addEventListener("turbolinks:load", setup);
